class Subscribe {
  constructor(el, fields) {
    this.el = el;
    this.fields = this.el.querySelectorAll('input');
    this.emailField = this.el.querySelector('[data-js-subscribe-email]');

    this.el.addEventListener(
      'submit',
      e => {
        e.preventDefault();
        this.handleSubmit();
      },
      true
    );
  }

  handleSubmit() {
    let fieldStatus = [];
    let button = this.el.querySelector('button');
    let loader = this.el.querySelector('.c-form__loader');

    this.removeMessage('form-error');

    for (let i = 0; i < this.fields.length; i++) {
      let field = this.fields[i];

      fieldStatus[i] = this.isValid(field);
      field.setAttribute('aria-invalid', !fieldStatus[i]);

      if (!fieldStatus[i]) {
        this.appendError(field);
      }
    }

    if (fieldStatus.includes(false)) {
      return;
    }

    let args = {
      action: 'newsletter_subscribe'
    };

    Object.assign(args, this.getValues());

    button && button.setAttribute('disabled', 'disabled');
    loader && loader.classList.add('loading');

    jQuery.post(myAjax.ajaxurl, args, response => {
      if (response.success == false) {
        this.fail(response.message);
        button && button.removeAttribute('disabled');
        loader && loader.classList.remove('loading');
      } else {
        this.success(response.id, response.name);
      }
    });
  }

  success(id, name) {
    this.handleTracking();
    window.location.replace('/signup-success?id=' + id + '&uname=' + name);
  }

  fail(status) {
    if (status === 'Invalid email address') {
      this.emailField.setAttribute('aria-invalid', true);
    }

    if (!this.el.querySelector('.validation_error')) {
      this.addMessage(status, 'validation_error');
    }

    this.removeMessage('form-success');
  }

  addMessage(status, className) {
    const message = document.createElement('p');

    message.classList.add(className);
    message.innerHTML = 'An error occured. Please try again later.';

    this.el.append(message);
    this.el.reset();
  }

  removeMessage(className) {
    let els = this.el.querySelectorAll('.' + className);
    if (els.length > 0) {
      for (let i = 0; i < els.length; i++) {
        els[i].remove();
      }
    }
  }

  getValues() {
    return Object.values(this.el).reduce((obj, field) => {
      obj[field.name] = field.value;
      return obj;
    }, {});
  }

  handleTracking() {
    dataLayer.push({ event: 'newsletterRegistration' });
  }

  isValid(field) {
    if (field.required && field.value === '') {
      return false;
    }

    if (
      field.type === 'email' &&
      field.value !== '' &&
      !this.validateEmail(field.value)
    ) {
      return false;
    }

    return true;
  }

  appendError(field) {
    var error = document.createElement('span');

    error.setAttribute('role', 'alert');
    error.classList.add('form-error');

    error.innerHTML =
      field.type === 'email'
        ? 'Please supply a valid email.'
        : 'This field is required.';

    field.parentNode.append(error);
    field.parentNode.classList.add('error');
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
    return re.test(String(email).toLowerCase());
  }
}

const subscribeForm = document.querySelector('[data-js-subscribe]');

if (subscribeForm) {
  const subscribe = new Subscribe(subscribeForm);
}
